<template>
    <div class="row mb-3">
        <div class="col-lg-4">
            <div class="form-group">
                <label>Customer Type</label>
                <v-select
                    v-model="filters.customerType"
                    :options="customerTypes"
                    placeholder="Select a customer type"
                    label="name"
                />
            </div>
        </div>
    </div>

    <table ref="table" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
        <thead>
            <tr>
                <th>Name</th>
                <th>Contact</th>
                <th>Address</th>
                <th>Type</th>
                <th>Actions</th>
            </tr>
        </thead>
        <tbody></tbody>
    </table>
</template>

<script setup>
import { onMounted, reactive, ref, watch } from "vue";
import VSelect from 'vue-select';

const props = defineProps({
    ajaxUrl: String,
});

const table = ref(null);
const filters = reactive({
    customerType: null,
});

const customerTypes = [
    { id: 0, name: 'Not Assigned' },
    { id: 1, name: 'Pro Forma' },
    { id: 6, name: 'Credit (14 Day)' },
    { id: 2, name: 'Credit (30 Day)' },
    { id: 5, name: 'Credit (45 Day)' },
    { id: 3, name: 'Credit (60 Day)' },
    { id: 4, name: 'On Hold' },
    { id: 7, name: 'End of Month (30 Day)' },
    { id: 8, name: 'End of Month (60 Day)' },
];

onMounted(() => {
    const dataTable = window.jQuery(table.value).on('preXhr.dt', (e, settings, data) => {
        data.filters = filters;
    }).dataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ajax: {
            url: props.ajaxUrl,
        },
        order: [[0, 'asc']],
        columns: [
            {
                data: 'name',
            },
            {
                data: 'accountcontact_name',
                width: '200px',
            },
            {
                data: 'full_address',
                orderable: false,
                searchable: false,
            },
            {
                data: 'type',
                searchable: false,
                orderable: false,
                width: '200px',
                render: function ( data, type, row ) {
                    return row.computed_type;
                },
            },
            {
                data: 'actions',
                width: '200px',
                searchable: false,
                orderable: false,
            },
            {
                data: 'accountcontact_email',
                visible: false,
            },
        ]
    });

    watch(
        filters,
        () => dataTable.api().ajax.reload(null, false),
        {
            deep: true,
        }
    );
});
</script>
